import { Controller } from "@hotwired/stimulus"
// Relative, and not the `app/packs/src/…` spelling every React file uses:
// those are resolved by vite-tsconfig-paths, which only handles importers that
// are part of the TypeScript project. This file is plain JavaScript under
// app/javascript, so the aliased form fails the build outright.
import { trackEvent } from "../../packs/src/services/event-tracker"

// PROG-748 sheet event 8, "Learning Opened from Coach".
//
// The one coach event that cannot be emitted from Ruby: it is a click on a link
// that leaves for linkedin.com, and the server never hears about it.
//
// The `$` is spelled out here. EventTracker::Tracker prepends one to every
// Rails-side event, the browser has no such wrapper, and the two paths have to
// agree or this arrives in Mixpanel as a second, near-identical event.
const LEARNING_OPENED = "$track_coach_learning_opened"

// The standard context from the sheet's "Read me" is computed in Ruby
// (CoachTracking::BaseProperties) and handed down as one value, rather than
// rebuilt here from whatever the page happens to know. Two definitions of a
// level band is one too many.
export default class extends Controller {
  static values = { base: Object, chatId: String }

  learningOpened() {
    trackEvent(LEARNING_OPENED, {
      ...this.baseValue,
      coach_session_id: this.chatIdValue || null,
      // The sheet asks which capability the click came from, and here it is a
      // constant rather than something to look up: this card is only ever
      // rendered by the skill_learning_material tool, which
      // CoachTracking::Capability maps to exactly this one.
      capability: "closing_the_gap",
      // The provider, never the resource. A course title says which skill the
      // coach thinks this person is short on, which is the specifics of their
      // situation the guardrails rule out.
      provider: "linkedin_learning",
    })
  }
}
